import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'context/AuthContext';
import { useGetCurrentSessionUser } from 'hooks/useGetCurrentSessionUser';
import { currentSelectedClientType } from 'features/Client/useSwitchClientList';
import { getAccountGroups } from './api';
import { FetchAccountGroupsRequest, FetchAccountGroupsResponse } from './types';
import { formatOption } from 'utils';


const transformData = (data: FetchAccountGroupsResponse) => {
    return {
        ...data,
        accountGroupList: formatOption(data?.accountGroupList)
    }
}


export function useGetAccountGroups({ accountNumber }: Omit<FetchAccountGroupsRequest, 'subClientId'>) {
    const { user } = useAuth();
    const currentSelectedClient = useGetCurrentSessionUser('currentSelectedClient') as currentSelectedClientType;
    const subClientId = currentSelectedClient?.clientId ?? user?.clientId;

    // QUERY
    const query = useQuery({
        queryKey: ["changeAccountGroupsInitData", accountNumber],
        queryFn: async () => {
            const { data } = await getAccountGroups({ subClientId, accountNumber })
            return transformData(data)
        },
        cacheTime: 0,
        staleTime: 0,
        enabled: !!accountNumber
    });


    return query;
}